import useSWR from 'swr';
import { dynamicProfilingService } from '@/services/api';
import { config } from '@/config';
import { IDynamicProfilingPostData } from '@/types/types';
import { getCurrentLocaleData } from '@/utils';
import { useLocale } from '@/hooks/general/useLocale/useLocale';
import { useCurrentPath } from '@/hooks/general/useCurrentPath/useCurrentPath';

export const useDynamicProfilingQuery = (
    postData?: IDynamicProfilingPostData,
    sessionId?: number,
) => {
    const API_URL = config.api.url.dynamicProfiling;

    const { locale } = useLocale();
    const { pathname } = useCurrentPath();

    const { languageAttribute, countryAttribute } = getCurrentLocaleData(locale);

    const { data } = useSWR(`${API_URL}/widget`, () =>
        dynamicProfilingService.getData({
            attributes: [languageAttribute, countryAttribute],
            path: pathname,
            postData,
            sessionId,
        }),
    );

    return data;
};
